import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RegisteredVolunteers = ({ volunteers, totalCount, maxCount }) => {
  const displayVolunteers = volunteers?.slice(0, 8);
  const remainingCount = totalCount - displayVolunteers?.length;

  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-[var(--color-foreground)]">Registered Volunteers</h2>
        <span className="text-sm text-[var(--color-muted-foreground)]">
          {totalCount} / {maxCount} spots filled
        </span>
      </div>
      <div className="relative h-3 bg-[var(--color-muted)] rounded-full overflow-hidden">
        <div 
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] rounded-full transition-all duration-500"
          style={{ width: `${(totalCount / maxCount) * 100}%` }}
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {displayVolunteers?.map((volunteer) => (
          <div key={volunteer?.id} className="flex items-center gap-3 bg-[var(--color-muted)] rounded-lg p-3">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <Image 
                src={volunteer?.avatar} 
                alt={volunteer?.avatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-[var(--color-foreground)] truncate">{volunteer?.name}</p>
              <p className="text-sm text-[var(--color-muted-foreground)] truncate">{volunteer?.role}</p>
            </div>
            {volunteer?.isTeamLead && (
              <div className="w-8 h-8 rounded-full bg-[var(--color-accent)]/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Star" size={16} color="var(--color-accent)" />
              </div>
            )}
          </div>
        ))}
      </div>
      {remainingCount > 0 && (
        <div className="text-center py-4 bg-[var(--color-muted)] rounded-lg">
          <p className="text-[var(--color-muted-foreground)]">
            + {remainingCount} more volunteers registered
          </p>
        </div>
      )}
      <div className="flex items-center gap-2 text-sm text-[var(--color-muted-foreground)] pt-4 border-t border-[var(--color-border)]">
        <Icon name="Users" size={16} />
        <span>Join {totalCount} volunteers making a difference</span>
      </div>
    </div>
  );
};

export default RegisteredVolunteers;